import { useMemo } from 'react';
import { Screen, Form as FormType } from '../types';

interface UseOneToManyScreensReturn {
    oneToManyScreens: Record<string, Screen>;
}

export const useOneToManyScreens = (
    form: FormType,
    allScreens: Screen[]
): UseOneToManyScreensReturn => {
    const oneToManyScreens = useMemo(() => {
        const oneToManyFields = form.fields.filter(f => f.type === 'one-to-many' && f.screenId);
        const screensMap: Record<string, Screen> = {};

        oneToManyFields.forEach(field => {
            if (field.screenId) {
                const screen = allScreens.find(s => s.id === field.screenId);
                if (screen) {
                    screensMap[field.code] = screen;
                }
            }
        });

        return screensMap;
    }, [form.fields, allScreens]);

    return { oneToManyScreens };
};
